//import {  } from ‘../constants/appConstant’;
export default function (state = {}, action) {
   switch(action.type) {
      case "GET_ITEMS_LIST":
         return { ...state, itemListData: action.payload.itemListData };
      default:
         return state;
   }
}